import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';
import { EmptyBalanceAlert } from './empty-balance-alert';
import { EmptyBalanceAlertWithPayLink } from './empty-balance-alert-with-pay-link';
import { PaymentsBlockedAlert } from './payments-blocked-alert';
import { useCurrentClinicHasPaymentMethod } from 'lib/hooks/tanstack/use-getProductPrice';
import { useClinicAssessmentBalance } from 'lib/hooks/tanstack/use-clinicAssessmentBalance';
import { Spin } from 'antd';

interface AssessmentBalanceAlertsProps {
  assessmentType: AssessmentType | undefined;
}

export function AssessmentBalanceAlerts(props: AssessmentBalanceAlertsProps) {
  const hasPaymentMethodQuery = useCurrentClinicHasPaymentMethod();
  const balanceQuery = useClinicAssessmentBalance(props.assessmentType);

  if (hasPaymentMethodQuery.isFetching || balanceQuery.isFetching) {
    return <Spin />;
  }

  const isInfinite = balanceQuery.data?.data.isInfinite;
  const emptyBalance = balanceQuery.data?.data.available === 0;

  const supportsOnDemand =
    balanceQuery.data?.data.supportsOnDemandPurchases.value;
  const hasPaymentMethod = hasPaymentMethodQuery.data?.data.hasPaymentMethod;

  if (isInfinite || !emptyBalance) {
    return null;
  }

  if (props.assessmentType === undefined) {
    return null;
  }
  
  if (!hasPaymentMethod) {
    return <PaymentsBlockedAlert />;
  }

  if (supportsOnDemand) {
    return (
      <EmptyBalanceAlertWithPayLink assessmentType={props.assessmentType} />
    );
  }
  return <EmptyBalanceAlert assessmentType={props.assessmentType} />;
}
